"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerceToSafeIntOrThrow = exports.coerceToSafeInt = exports.CoerceToSafeIntStatus = exports.integerFromStringCodec = exports.nonNegativeIntegerFromStringCodec = exports.safeNonNegativeIntCodec = exports.safeIntCodec = exports.boundedIntFromString = exports.boundedInt = void 0;
const io_ts_1 = require("io-ts");
const NumberFromString_1 = require("io-ts-types/NumberFromString");
/**
 * @param min Inclusive
 * @param max Inclusive
 */
const boundedInt = (min, max) => (0, io_ts_1.brand)(io_ts_1.Int, (int) => {
    return int >= min && int <= max;
}, "BoundedInt");
exports.boundedInt = boundedInt;
const boundedIntFromString = (min, max) => NumberFromString_1.NumberFromString.pipe((0, exports.boundedInt)(min, max));
exports.boundedIntFromString = boundedIntFromString;
/**s
 * Codec that confirms that an input value is an integer that is small enough to
 * be safely expressed as a native JavaScript number
 */
exports.safeIntCodec = (0, exports.boundedInt)(Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
exports.safeNonNegativeIntCodec = (0, exports.boundedInt)(0, Number.MAX_SAFE_INTEGER);
/**
 * A custom codec to that decodes numeric strings to safely expressable integers
 * allowing non-negative values only
 */
exports.nonNegativeIntegerFromStringCodec = NumberFromString_1.NumberFromString.pipe(exports.safeNonNegativeIntCodec);
/**
 * A custom codec to that decodes numeric strings to safely expressable integers
 */
exports.integerFromStringCodec = NumberFromString_1.NumberFromString.pipe(exports.safeIntCodec);
/**
 * Potential statuses of `coerceToSafeInt()`
 */
var CoerceToSafeIntStatus;
(function (CoerceToSafeIntStatus) {
    /**
     * Number is a safely-sized integer value as is
     */
    CoerceToSafeIntStatus["IS_SAFE_INT"] = "IS_SAFE_INT";
    /**
     * Number was not a integer, but after rounding down, is safely sized
     */
    CoerceToSafeIntStatus["ROUNDED_DOWN"] = "ROUNDED_DOWN";
    /**
     * Could not coerce to a safely-sized integer - likely that the number is too
     * large to be safely expressed as an integer with Javascript `number`
     */
    CoerceToSafeIntStatus["COULD_NOT_COERCE"] = "COULD_NOT_COERCE";
})(CoerceToSafeIntStatus || (exports.CoerceToSafeIntStatus = CoerceToSafeIntStatus = {}));
/**
 * Coerces a given number to a safe int by checking that it matches the
 * `safeIntCodec`
 */
function coerceToSafeInt(params) {
    if (exports.safeIntCodec.is(params.num)) {
        return {
            status: CoerceToSafeIntStatus.IS_SAFE_INT,
            num: params.num,
        };
    }
    if (params.round) {
        const roundedDown = parseInt(params.num.toString());
        if (exports.safeIntCodec.is(roundedDown)) {
            return {
                status: CoerceToSafeIntStatus.ROUNDED_DOWN,
                num: roundedDown,
            };
        }
    }
    return {
        status: CoerceToSafeIntStatus.COULD_NOT_COERCE,
    };
}
exports.coerceToSafeInt = coerceToSafeInt;
function coerceToSafeIntOrThrow(params) {
    const coerceResult = coerceToSafeInt(params);
    if (coerceResult.status !== CoerceToSafeIntStatus.IS_SAFE_INT) {
        throw new Error(`${params.num} is not a safe integer value. Coercing returned status: ${coerceResult.status}.`);
    }
    return coerceResult.num;
}
exports.coerceToSafeIntOrThrow = coerceToSafeIntOrThrow;
//# sourceMappingURL=number.js.map